import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Create from '@material-ui/icons/Create';
import Refresh from '@material-ui/icons/Refresh';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import CustomButton from 'components/CustomButtons/Button';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import EditCell from 'views/TopUp/subcomponents/EditCell';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ActionsProps {
	row: types.topUp.TableRow;
	setTemporaryValue: (value: string) => void;
	resetTemporaryValue: () => void;
	setValue: (value: string, index: number) => void;
	resetValue: (index: number) => void;
	temporaryValue: string;
	topupValue: number;
	showEdit: () => void;
	closeEdit: () => void;
	minEditedSelected?: number;
}

const Actions = (props: ActionsProps) => {
	const classes = useStyles();

	return (
		<ConditionalRender
			show={props.row.original.topUpValue !== props.topupValue}
			onTrue={() => (
				<CustomButton
					justIcon
					color="tertiary-light"
					className={classes.editIcon}
					onClick={() => props.resetValue(props.row.index)}
				>
					<Refresh />
				</CustomButton>
			)}
			onFalse={() => (
				<ConditionalRender
					show={props.row.index === props.minEditedSelected}
					onTrue={() => (
						<EditCell
							setTemporaryValue={props.setTemporaryValue}
							resetTemporaryValue={props.resetTemporaryValue}
							setValue={(value: string) => props.setValue(value, props.row.index)}
							temporaryValue={props.temporaryValue}
							closeEdit={props.closeEdit}
						/>
					)}
					onFalse={() => (
						<CustomButton
							color="tertiary-light"
							justIcon
							onClick={props.showEdit}
							className={classes.editIcon}
						>
							<Create />
						</CustomButton>
					)}
				/>
			)}
		/>
	);
};

export default Actions;
